import React from 'react';

function optionText(children) {
  return React.Children.toArray(children).map(child => React.isValidElement(child)
    ? optionText(child.props.children) : String(child)).join('');
}

const SelectOptions = ({ children, id }) => React.Children.toArray(children).map((option, index) => {
  const text = optionText(option.props.children);
  const value = option.props.value ?? text;
  return React.createElement('option', {
    key: String(value), value, disabled: option.props.disabled,
    'data-testid': `${id}-option-${index}`,
  }, text);
});

// Intentionally allowlist native attributes rather than forwarding component-only props.
export const Select = ({
  id, label, children, value, defaultValue, onChange, disabled, required, name,
  multiple, size, className, onBlur, onFocus, autoFocus, form, tabIndex,
  'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy,
  'aria-describedby': ariaDescribedBy, 'aria-invalid': ariaInvalid,
}) => <label className="field" htmlFor={id}>
  <span>{label}</span>
  <select id={id} data-testid={id} value={value} defaultValue={defaultValue}
    onChange={onChange} disabled={disabled} required={required} name={name}
    multiple={multiple} size={size} className={className} onBlur={onBlur} onFocus={onFocus}
    autoFocus={autoFocus} form={form} tabIndex={tabIndex} aria-label={ariaLabel}
    aria-labelledby={ariaLabelledBy} aria-describedby={ariaDescribedBy} aria-invalid={ariaInvalid}>
    <SelectOptions id={id}>{children}</SelectOptions>
  </select>
</label>;